/**
 * The hover wash for inline-styled controls, and the one hook that drives it.
 *
 * These used to live in `glass.tsx`. They moved out when the glass fill became
 * a token with a test guarding it, because that test's rule is "no colour
 * literal in the glass recipe file" and a hover wash is not glass — it is a
 * transient tint painted INSIDE a glass surface, on top of the fill. Keeping
 * the two in one file would have meant either exempting a colour from the rule
 * or pretending a hover state is a material.
 */

import { useState } from 'react'
import type { Theme } from '../../core/store'

export const hoverFill = (theme: Theme, on: boolean): string =>
  on ? (theme === 'dark' ? 'rgba(255,255,255,0.07)' : 'rgba(48,40,28,0.06)') : 'transparent'

/** One hover state per interactive element, without a stylesheet. */
export function useHover(): [boolean, { onMouseEnter: () => void; onMouseLeave: () => void }] {
  const [on, setOn] = useState(false)
  return [on, { onMouseEnter: () => setOn(true), onMouseLeave: () => setOn(false) }]
}
